const featuresPay = {
    featureTitle: 'Buat Keputusan Perniagaan Berdasarkan Data',
    featureDescription:
        'Ketahuilah barang mana yang paling banyak terjual dan memberikan keuntungan tertinggi, serta akses laporan kewangan bila-bila masa, di mana sahaja. Perniagaan anda di hujung jari!',
    featureButton: "Langganan Premium",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: ' Bermula dari',
    featureEndingText: 'Ribu',

    features: [
        {
            title: 'Item Tanpa Had',
            description: 'Tambah semua barang yang anda miliki tanpa sebarang had.'
        },
        {
            title: 'Kakitangan Tanpa Had',
            description: 'Tambah Kakitangan/Pentadbir ke perniagaan tanpa sebarang had.'
        },
        {
            title: 'Sejarah Tanpa Had',
            description: 'Lihat perubahan rekod stok lama tanpa sebarang had.'
        },
        {
            title: 'Penapis Sejarah',
            description: 'Lihat sejarah dengan mudah berdasarkan jenis, kategori, kakitangan, dan tarikh.'
        },
        {
            title: 'Muat Turun ke Excel',
            description: 'Dapatkan sejarah rekod stok ke dalam Microsoft Excel dengan satu klik.'
        },
        {
            title: 'Muat Turun ke PDF',
            description: 'Dapatkan senarai barang dan stok terkini ke dalam PDF dengan satu klik.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Cipta berbilang gudang untuk pengurusan stok yang lebih baik.'
        },
        {
            desc: 'Tetapkan produk ke lokasi tertentu.'
        },
        {
            desc: 'Pantau tahap inventori di semua gudang.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Tambah varian saiz, warna, atau bahan.' },
        { desc: 'Tetapkan tahap stok bagi setiap varian.' },
        { desc: 'Jejaki merentasi gudang.' }
    ]
}
export default featuresPay